import { useState } from "react";
import { Box, Typography, Paper, Stack, TextField, Button, Alert, Grid2 as Grid } from "@mui/material";
import { PageHeader } from "@/components/PageHeader";
import { useQuery } from "@tanstack/react-query";
import { diagnosticsApi } from "@/api/diagnostics";
import { errorMessage } from "@/api/client";

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <Paper sx={{ p: 2, textAlign: "center" }}>
      <Typography variant="h4" fontWeight={600}>{value}</Typography>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
    </Paper>
  );
}

export function LabTatPage() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [applied, setApplied] = useState<{ from?: string; to?: string }>({});

  const query = useQuery({
    queryKey: ["dx-tat", applied],
    queryFn: () => diagnosticsApi.labTat(applied),
  });
  const s = query.data;

  return (
    <Box>
      <PageHeader breadcrumbs={["Diagnostics"]} title="Lab turnaround (TAT)" />
      <Paper sx={{ p: 2, mb: 2 }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <TextField label="From" type="datetime-local" size="small" InputLabelProps={{ shrink: true }} value={from} onChange={e => setFrom(e.target.value)} />
          <TextField label="To" type="datetime-local" size="small" InputLabelProps={{ shrink: true }} value={to} onChange={e => setTo(e.target.value)} />
          <Button variant="contained" onClick={() => setApplied({ from: from || undefined, to: to || undefined })}>Apply</Button>
          <Typography variant="caption" color="text.secondary">Defaults to the last 30 days.</Typography>
        </Stack>
      </Paper>
      {query.isError && <Alert severity="error">{errorMessage(query.error)}</Alert>}
      {s && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, md: 2 }}><Stat label="Results" value={s.count} /></Grid>
          <Grid size={{ xs: 6, md: 2 }}><Stat label="Avg (min)" value={s.averageMinutes} /></Grid>
          <Grid size={{ xs: 6, md: 2 }}><Stat label="Median (min)" value={s.medianMinutes} /></Grid>
          <Grid size={{ xs: 6, md: 2 }}><Stat label="P90 (min)" value={s.p90Minutes} /></Grid>
          <Grid size={{ xs: 6, md: 2 }}><Stat label="Min (min)" value={s.minMinutes} /></Grid>
          <Grid size={{ xs: 6, md: 2 }}><Stat label="Max (min)" value={s.maxMinutes} /></Grid>
        </Grid>
      )}
    </Box>
  );
}
